import { TEffectiveRoleMap, TValidUserRoles } from '../../shared/typings/interfaces/user.interface';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

interface IUserRolePermissionsForGuards {
  // urlName reflects paths set in ROUTE_CONFIGS (in routes.config.ts)
  [urlName: string]: TValidUserRoles[];
}

export const USER_ROLE_PERMISSIONS_FOR_GUARDS: IUserRolePermissionsForGuards = {
  'shelter/:shelterId/lists/attendance-list': ['shelter_cluster_admin', 'shelter_view_all'],
  'shelter/:shelterId/grid': ['shelter_cluster_admin', 'shelter_view_all'],
  'shelter/:shelterId/profile': ['shelter_cluster_admin', 'shelter_view_all'],
  'shelter-picker': ['shelter_cluster_admin', 'shelter_only'],
  'network/shelter/settings': ['shelter_cluster_admin'],
};
